var __TEMP__ = require('./_baseIsTypedArray.js');var baseIsTypedArray = __REQUIRE_DEFAULT__(__TEMP__);
var __TEMP__ = require('./_baseUnary.js');var baseUnary = __REQUIRE_DEFAULT__(__TEMP__);
var __TEMP__ = require('./_nodeUtil.js');var nodeUtil = __REQUIRE_DEFAULT__(__TEMP__);

/* Node.js helper references. */
var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

if (!exports.__esModule) Object.defineProperty(exports, "__esModule", { value: true });exports.default = isTypedArray;
